import { createApi } from '@reduxjs/toolkit/query/react'
import { createBffApiBaseQuery } from './apiClients'

export const emotesApi = createApi({
    reducerPath: 'emotesApi',
    baseQuery: createBffApiBaseQuery('emotesApi', { baseUrl: `${process.env.REACT_APP_API_BASE_URL}/emotes` }),
    endpoints: (builder) => ({
        getCurrentUserEmotes: builder.query({
            query: () => `/users/current`,
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response.status
        }),
        getGlobalTwitchEmotes: builder.query({
            query: () => `/global`,
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response.status
        })
    }),
})

export const { useGetCurrentUserEmotesQuery, useGetGlobalTwitchEmotesQuery } = emotesApi
